import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { BASE_URL } from "../../constants";
import axios from 'axios';

const RightWrongQuestModal = ({ show, handleClose }) => {

    const [rightWrongRows, setRightWrongRows] = useState([
        {
            assessmentId: '',
            questionId: '',
            lable: '',
            quest_type: '',
            score: '',
            sort_order: '',
            ans_type: '',
            answer: '',
            score: '',
            status: '',
            questMand: ''
        }]);

    const [selAnswers, setSelAnswers] = useState([]);

    //   const [parkTypes, setParkTypes] = useState([]);
    //   const [carMaintComp, setCarMaintComp] = useState([]);
    //   const [bikeMaintComp, setBikeMaintComp] = useState([]);

    useEffect(() => {

        // const fetchLists = async () => {
        //   try {
        //     const [parktypeRes, carMaintRes, bikeMaintRes, parkingSlotRes] = await Promise.all([
        //       axios.get(`${BASE_URL}/api/ddl_parking_types`),
        //     ]);

        //     setParkTypes(parktypeRes.data);
        //     setCarMaintComp(carMaintRes.data);
        //     setBikeMaintComp(bikeMaintRes.data);

        //     if (parkingSlotRes.data.length > 0) {
        //        setPakingRows(parkingSlotRes.data);
        //     }
        //     else {
        //       setPakingRows([{ irn: '', parktype_id: '', level: '', from_date: '', car_maint_id: '', car_chrg: '', from_car: '', to_car: '',
        //                        bike_maint_id: '', bike_chrg: '', from_bike: '', to_bike: '' }]);
        //     }

        //   } catch (err) {
        //     console.error("Dropdown fetch error:", err);
        //   }
        // };

        // fetchLists();

    }, []);

    const handleChange = (index, field, value) => {
        const updatedRows = [...rightWrongRows];
        updatedRows[index][field] = value;
        setRightWrongRows(updatedRows);
    };

    const onSave = async () => {

        try {

            //   let lv_err_msg = '';

            //   for (let i = 0; i < pakingrows.length; i++) {

            //     if (!pakingrows[i].parktype_id || pakingrows[i].parktype_id === '') {
            //         lv_err_msg = 'Please select Parking Type at Row # ' + (i + 1);
            //         break;
            //     }
            //     if (!pakingrows[i].level || pakingrows[i].level === '') {
            //         lv_err_msg = 'Please enter Level at Row # ' + (i + 1);
            //         break;
            //     }
            //     if (!pakingrows[i].from_date) {
            //         lv_err_msg = 'Please enter From Date at Row # ' + (i + 1);
            //         break;
            //     }
            //     if (pakingrows[i].from_car && pakingrows[i].to_car && pakingrows[i].from_car > pakingrows[i].to_car) {
            //         lv_err_msg = 'Four-Wheeler From Slot is greater than To Slot at Row # ' + (i + 1);
            //         break;
            //     }
            //     if (pakingrows[i].from_bike && pakingrows[i].to_bike && pakingrows[i].from_from_bike > pakingrows[i].to_bike) {
            //         lv_err_msg = 'Two-Wheeler From Slot is greater than To Slot at Row # ' + (i + 1);
            //         break;
            //     }
            //     if (pakingrows[i].from_car > 0 && pakingrows[i].to_car > 0 && 
            //         (!pakingrows[i].car_chrg || pakingrows[i].car_chrg === 0) ) {
            //         lv_err_msg = 'Please enter the Parking Amount for Four-Wheeler at Row # ' + (i + 1);
            //         break;
            //     }
            //     if (pakingrows[i].from_bike && pakingrows[i].to_bike && (!pakingrows[i].bike_chrg || pakingrows[i].bike_chrg === 0) ) {
            //         lv_err_msg = 'Please enter the Parking Amount for Two-Wheeler at Row # ' + (i + 1);
            //         break;
            //     }

            //   }

            //   if (lv_err_msg) {
            //     alert(lv_err_msg);
            //     return;
            //   }

            //   const isConfirmed = window.confirm("Sure you want to save the Yes/No Question Sets ?");

            //   if (!isConfirmed) {
            //     return;
            //   }

            //   const data = { parkingData: pakingrows };

            //   const response = await axios.post(`${BASE_URL}/api/save_yesno_question`, data);

            //   if (response.data.message === '1') {
            //     alert('Parking saved successfully !');
            //   }

            handleClose();

        } catch (error) {
            alert('save error ', error);
        }

    };

    const addRow = () => {

        const newIndex = rightWrongRows.length + 1; // 1-based index
        const newRow = {
            assessmentId: '', questionId: '', lable: '', quest_type: '', sort_order: '',
            ans_type: '', answer: '', score: '', status: '', questMand: '',
            //      dispOrder: newIndex,
        };

        setRightWrongRows([...rightWrongRows, newRow]);

    };

    const removeRow = (index) => {

        const row = rightWrongRows[index];

        // Prevent deletion if IRN exists and is greater than 0
        if (row.questionId && row.questionId > 0) {
            alert('Cannot delete an existing Question.');
            return;
        }

        const updated = rightWrongRows.filter((_, i) => i !== index);
        setRightWrongRows(updated);
    };

    return (
        <Modal show={show} onHide={handleClose} size="xl" centered backdrop="static" keyboard={false}>
            <Modal.Header closeButton>
                <Modal.Title>Right/Wrong Questions</Modal.Title>
            </Modal.Header>
            <Modal.Body>

                <div style={{ minHeight: '350px' }} className="table-wrapper">
                    <table style={{ maxHeight: '38px' }} className="responsive-table-modal scty-custom-table">
                        <thead>
                            <tr>
                                <th style={{ width: '24%' }} >Question</th>
                                <th style={{ width: '6%', textAlign: 'right' }} >Marks</th>
                                <th style={{ width: '8%', textAlign: 'right' }} >Quest. Order</th>
                                <th style={{ width: '8%', textAlign: 'left' }}>Select Right Answer</th>
                                <th style={{ width: '5%' }}></th>
                            </tr>
                        </thead>
                        <tbody>
                            {rightWrongRows.map((row, index) => (
                                <tr key={index}>
                                    <td>
                                        <input className="form-control text-start"
                                            type="text"
                                            value={row.lable}
                                            onChange={(e) => handleChange(index, 'lable', e.target.value)}
                                        />
                                    </td>
                                    <td style={{ textAlign: 'left' }}>
                                        <input className="form-control text-end"
                                            type="number"
                                            value={row.score}
                                            onChange={(e) => handleChange(index, 'score', e.target.value)}
                                        />
                                    </td>
                                    <td>
                                        <input className="form-control text-end"
                                            type="number"
                                            value={row.sort_order}
                                            onChange={(e) => handleChange(index, 'sort_order', e.target.value)}
                                        />
                                    </td>
                                    <td>
                                        <select
                                            value={row.disc_type}
                                            onChange={(e) => handleChange(index, 'disc_type', e.target.value)}
                                            className="form-select">
                                            <option value="1">Right</option>
                                            <option value="0">Wrong</option>
                                        </select>
                                    </td>
                                    <td style={{ textAlign: 'center' }}>
                                        {rightWrongRows.length > 1 && (
                                            <Button variant="danger" onClick={() => removeRow(index)} size="sm">Delete</Button>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <div className="mb-3">
                    <Button style={{ marginTop: '10px' }} variant="primary" onClick={addRow}>Add Row</Button>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
                <Button variant="primary" onClick={onSave}>
                    Save
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default RightWrongQuestModal;
